import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Field, reduxForm, getFormValues} from 'redux-form';
import {withStyles} from '@mui/styles';
import Grid from '@mui/material/Grid';
import {CellType} from '@grapecity/wijmo.grid';
import Divider from '@mui/material/Divider';
import SearchIcon from '@mui/icons-material/Search';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import AddIcon from '@mui/icons-material/Add';
import {commonOperations} from '../../../../reducks/common';
import MainContainer from '../../../organisms/MainContainer.js';
import {HttpStatusCode} from 'axios';
import Typography from '@mui/material/Typography';
import {renderTextField, renderSelect,
  renderCheckbox, renderSelectMultiLine} from '../../../atoms/CustomPart.js';
import CustomFlexGrid, {createComponents} from '../../../molecules/CustomFlexGrid.js';
import {PositiveButton} from '../../../atoms/Buttons/PositiveButton.js';
import NegativeButton from '../../../atoms/Buttons/NegativeButton.js';
import PaperPart from '../../../atoms/PaperPart.js';
import withRouter from '../../../organisms/withRouter.js';
import {setSessionObject} from '../../../../common/Session.js';
import WarningMessageArea from '../../../molecules/WarningMessageArea.js';
import CustomBreadcrumbs from '../../../molecules/Breadcrumbs.js';
import CustomAccordion from '../../../molecules/Accordion.js';
import {getKbnList, sysErr} from '../../../../common/commonGmn.js';
import {postRequest} from '../../../../common/backend.js';
import {searchMap, getNewNwOfficeMap, searchCheck} from '../../../../common/common.js';
import {CATEGORY_TYPE, GMN, GMN_PATH, APPROVAL_STATUS, USER_TYPE_CODE,
  OPERATION_PERMISSION_TYPE, INPUT_TYPE} from '../../../../common/commonConst.js';
import {validate} from '../../../formValidate.js';

// パンくずパラメータ
const transitionList = [
  {gmnName: GMN.MENU.name, href: GMN_PATH.MENU},
  {gmnName: GMN.SURVEY_YEAR_COMPANY_LIST.name, href: ''},
];

const styles = (theme) => ({
  period: {
    lineHeight: 3.5,
    margin: '0 -8px 0 20px',
  },
});


// 調査年度・委託エリア
const surveyYearListViews = [
  {binding: 'orderNo', header: '申請番号', dataType: 'link', width: 150, isReadOnly: true},
  {binding: 'nwOffice', header: 'NW事業所', dataType: 'String', width: 130, isReadOnly: true},
  {binding: 'issuerUser', header: '作成者', dataType: 'String', width: 110, isReadOnly: true},
  {binding: 'createDateStr', header: '作成日', dataType: 'String', width: 110, isReadOnly: true},
  {binding: 'approvalStatus', header: 'ステータス', dataType: 'String', width: 110, isReadOnly: true},
  {binding: 'nwOfficeCode', header: 'NW事業所コード', dataType: 'String', width: 1, isReadOnly: true, visible: false},
  {binding: 'surveyCompanyCode', header: '調査会社コード', dataType: 'String', width: 1, isReadOnly: true, visible: false},
];

/**
 * 調査年度・委託エリア管理
 * 画面ID:SCI1001
 */
class Container extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      warningMessages: [],
    };

    this.gridRef = React.createRef();
    this.setGridItems();
    this.isVisible = false;
  }

  /**
   * 画面項目設定
   */
  setGridItems = () => {
    let views = surveyYearListViews;
    views.forEach((view) => {
      if (view.binding == 'orderNo') {
        view.click = (e, ctx) => {
          this.doEditLink(ctx.item.orderNo,
              ctx.item.nwOfficeCode,
              ctx.item.surveyCompanyCode);
        };
      }
    });
  };

  /**
   * 初期処理
   */
  async componentDidMount() {
    await this._initialValue();
    this.doSearch();
  }

  /**
   * 画面項目初期化
   */
  _initialValue = async () => {
    const {userInfo, menuItems} = this.props;
    let initItems = {};
    initItems['nwOfficeCode'] = userInfo.nwOfficeCode;
    this.isVisible = menuItems.some(
        (item) => item.gamenId === GMN.SURVEY_YEAR_COMPANY_LIST.gmnId &&
              item.operationPermissionType ===
                  OPERATION_PERMISSION_TYPE.EXECUTE);    // 実行権限
    if (userInfo.userTypeCode == USER_TYPE_CODE.NWC_KANRI) {
      initItems['approvalStatus'] = [APPROVAL_STATUS.SAKUSEI_TYU, APPROVAL_STATUS.SYONIN_TYU];
    }
    // NWC担当者の場合、ステータスは「作成中」を選定
    if (userInfo.userTypeCode == USER_TYPE_CODE.NWC_TANTOU) {
      initItems['approvalStatus'] = [APPROVAL_STATUS.SAKUSEI_TYU];
    }
    try {
      this.props.change('nwOfficeCode', initItems['nwOfficeCode'] );
      this.props.change('approvalStatus', initItems['approvalStatus'] );
    } catch (error) {
      sysErr(this.props);
    }
  };

  /**
   * 画面項目初期化
   */
  _reset = async () => {
    this.props.reset();
    await this._initialValue();
    this.gridRef.current.setItemsSource(null);
  };

  /**
   * 終了処理
   */
  async componentWillUnmount() {
    this.props.reset();
    this.props.doSetInitValues(null);
  }

  /**
   * 検索ボタン押下時処理
   * @param {bool} show
   */
  doSearch = async () => {
    const {userInfo, values} = this.props;
    let searchNwCodes = [];
    if (values.nwOfficeCode == null||values.nwOfficeCode == '') {
      searchNwCodes=userInfo.authNwOfficeCodes;
    } else {
      searchNwCodes=[values.nwOfficeCode];
    }
    try {
      let _body = {
        searchConditionModel: values,
        surveyCompanyCode: userInfo.corpCd,
        nwOfficeCodes: searchNwCodes,
        inputType: INPUT_TYPE.SURVEY_YEAR,
      };
      // リクエスト出す
      let _url = 'sci1001/survey-year-company-search';
      const response = await postRequest(_url, _body);
      if (response.status != HttpStatusCode.Ok) {
        if (response.data?.message != null) {
          this.props.doShowMessage({
            message: {id: response.data?.message.id,
              text: response.data?.message.text},
          });
        }
        return;
      }
      let _warningMessages = searchCheck(response.data.inputformInfoList);
      this.setState({warningMessages: _warningMessages});
      if (this.gridRef?.current) {
        this.gridRef.current.setItemsSource(
            response.data.inputformInfoList);
      }
    } catch (error) {
      sysErr(this.props);
    }
  };

  /**
   * 新規作成ボタン押下時
   */
  doTenNext = async () => {
    try {
      let params = {
        orderNo: '',
        transitionList: transitionList,
      };
      params.transitionList[1].href = GMN_PATH.SURVEY_YEAR_COMPANY_LIST;
      // 調査年度・委託エリア登録画面に遷移
      setSessionObject(GMN.SURVEY_YEAR_COMPANY_INFO.id, params);
      this.props.navigate(GMN_PATH.SURVEY_YEAR_COMPANY_INFO);
    } catch (error) {
      sysErr(this.props);
    }
  };


  /**
   * 一覧表示
   * @return {object}
   */
  renderTable() {
    const props = {
      rowHeaderType: 'none',
      filterOn: true,
      headersVisibility: 'Column',
      allowDragging: 'Columns',
      allowSorting: 'SingleColumn',
      AddDeleteOn: false,
      style: {maxHeight: '300pt', maxWidth: '100%', height: 'auto', width: 'auto'},
      isReadOnly: true,
      isDisplayCount: true,
      formatItemFunction: this.formatItemFunction,
    };
    const component = createComponents(surveyYearListViews);
    return (
      <CustomFlexGrid ref = {this.gridRef} {...props}>
        {component}
      </CustomFlexGrid>
    );
  }

  /**
   * 項目フォーマット処理
   * @param {object} s sender
   * @param {string} e event
   */
  formatItemFunction = (s, e) => {
  // 行が存在しない場合は終了
    const rows = s.rows;
    if (rows.length == 0) {
      return;
    }
    if (e.panel.cellType == CellType.Cell) {
      e.cell.style.backgroundColor = '';
    }
    if (e.panel.cellType == CellType.Cell) {
      const col = e.getColumn();
      const data = s.rows[e.row].dataItem;
      if (col && ((col.binding === 'approvalStatus' &&
      data.hiKetuFlag))) {
        e.cell.style.backgroundColor = '#ff0000';
      }
    }
  };

  /**
   * 一覧リンククリック時
   * @param {*} orderNo 申請番号
   * @param {*} nwOfficeCode NW事業所コード
   * @param {*} surveyCompanyCode 調査会社コード
   */
  doEditLink = async (orderNo, nwOfficeCode, surveyCompanyCode) => {
    try {
      let params = {
        orderNo: orderNo,
        nwOfficeCode: nwOfficeCode,
        surveyCompanyCode: surveyCompanyCode,
        transitionList: transitionList,
      };
      params.transitionList[1].href = GMN_PATH.SURVEY_YEAR_COMPANY_LIST;
      // SCI1002調査年度委託エリア画面に遷移
      setSessionObject(GMN.SURVEY_YEAR_COMPANY_INFO.id, params);
      this.props.navigate(GMN_PATH.SURVEY_YEAR_COMPANY_INFO);
    } catch (error) {
      sysErr(this.props);
    }
  };


  /**
   * 検索条件タブの要素生成
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  renderCondition() {
    const {genericMap, userInfo, classes} = this.props;
    const industryStatusList = searchMap(
        genericMap, CATEGORY_TYPE.SURVEY_YEAR_CONSIGN_AREA_STATUS);
    let approvalStatusList = getKbnList(industryStatusList);
    const hiketuList = searchMap(genericMap, CATEGORY_TYPE.NEGATION_LIST_CODE);
    let hiketuSeleceList = getKbnList(hiketuList);
    const nwJigyosyoList = getNewNwOfficeMap(
        genericMap, userInfo.authNwOfficeCodes);
    let nwOfficeList = getKbnList(nwJigyosyoList);
    return (
      <React.Fragment>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
          direction={'row'}
        >
          <Grid key="keySCI1001orderNo" item xs={12} sm={2}>
            <Field
              id="orderNo"
              name="orderNo"
              component={renderTextField}
              className="fields"
              label="申請番号"
              fullWidth
              type="text"
              required={false}
            />
          </Grid>
          <Grid key="keySCI1001nwOfficeCode" item xs={12} sm={2}>
            <Field
              id="nwOfficeCode"
              name="nwOfficeCode"
              component={renderSelect}
              className="fields"
              label="NW事業所"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              {nwOfficeList}
            </Field>
          </Grid>
          <Grid key="keySCI1001createDateStrFrom" item xs={12} sm={2}>
            <Field
              id="createDateStrFrom"
              name="createDateStrFrom"
              label="作成日"
              component={renderTextField}
              className="fields"
              type="date"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Typography className={classes.period}>～</Typography>
          <Grid key="keySCI1001createDateStrTo" item xs={12} sm={2}>
            <Field
              id="createDateStrTo"
              name="createDateStrTo"
              component={renderTextField}
              className="fields"
              type="date"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="keySCI1001approvalStatus" item xs={12} sm={2}>
            <Field
              id="approvalStatus"
              name="approvalStatus"
              component={renderSelectMultiLine}
              className="fields"
              label="ステータス"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              {approvalStatusList}
            </Field>
          </Grid>
          <Grid key="keySCI1001hiketu" item xs={12} sm={2}>
            <Field
              id="hiketu"
              name="hiketu"
              component={renderSelect}
              className="fields"
              label="否決"
              type="text"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              {hiketuSeleceList}
            </Field>
          </Grid>
          <Grid key="keySCI1001isMine" item xs={12} sm={3}>
            <Field className="checkbox"
              id="isMine"
              name="isMine"
              component={renderCheckbox}
              label="作成者（自分のみ）"
              validate={[]}
              sx={{marginLeft: '20px'}}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  };

  /**
   * フッタボタン
   * @return {JSX.Element}
   */
  renderFooterBtn() {
    const {
      handleSubmit,
    } = this.props;

    return (
      <Grid
        container
        justifyContent="center"
        alignItems="flex-start"
        spacing={1}
      >
        {this.isVisible &&<Grid key="keySCI1001CreateSen1" item>
          <PositiveButton
            id="btnSCI1001CreateSen1"
            onClick={handleSubmit(this.doTenNext)}
            variant="contained"
            startIcon={<AddIcon />}
          >
            <span>新規作成</span>
          </PositiveButton>
        </Grid>}
      </Grid>
    );
  };

  render() {
    const {
      handleSubmit,
    } = this.props;

    // フッタボタンを生成
    const footerBtn = this.renderFooterBtn();

    return (
      <form noValidate autoComplete="off" className="bf-form-root">
        <MainContainer
          props={this.props}
          footerBtn={this.isVisible && footerBtn}>
          <CustomBreadcrumbs key="keyBreadcrumbs" items={transitionList} />
          <Grid key="keySCI1001Msg" item xs={12}>
            <WarningMessageArea messages={this.state.warningMessages} />
          </Grid>
          <PaperPart>
            <Grid
              container
              justifyContent="flex-start"
              alignItems="flex-start"
              spacing={1}
            >
              <Grid key="search" item xs={12}>
                <CustomAccordion title='検索条件' items={[this.renderCondition()]} defaultExpanded={true} />
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent="right"
              alignItems="right"
            >
              <Grid key="clear" item>
                <NegativeButton
                  id="clear"
                  variant="contained"
                  startIcon={<RotateLeftIcon />}
                  className="button_list"
                  size="middle"
                  onClick={this._reset}
                >
                  <span>クリア</span>
                </NegativeButton>
              </Grid>
              <Grid key="search" item>
                <PositiveButton
                  id="search"
                  variant="contained"
                  startIcon={<SearchIcon />}
                  className="button_list"
                  size="middle"
                  onClick={handleSubmit(this.doSearch)}
                >
                  <span>検索</span>
                </PositiveButton>
              </Grid>
            </Grid>
          </PaperPart>
          <div style={{marginBottom: '10px'}} />
          <Divider variant="middle" />
          <Grid container
            justifyContent="flex-start"
            alignItems="flex-start"
          >
            <Grid key="keySCI1001List" item xs={12} style={{marginTop: '10px'}} >
              {this.renderTable()}
            </Grid>
          </Grid>
        </MainContainer>
      </form>
    );
  }
}

Container.propTypes = {
  genericMap: PropTypes.object,
  values: PropTypes.object,
  userInfo: PropTypes.object,
  reset: PropTypes.func,
  handleSubmit: PropTypes.func,
  doShowMessage: PropTypes.func,
  change: PropTypes.func,
  navigate: PropTypes.func,
  doSetInitValues: PropTypes.func,
  menuItems: PropTypes.object,
  classes: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    userInfo: state.auth.userInfo,
    genericMap: state.common.generalPurposeMap,
    initialValues: {},
    menuItems: state.auth.menuItems,
  };
};

const mapDispatchToProps = {
  doShowMessage: commonOperations.doShowMessage,
  doSetInitValues: commonOperations.doSetInitValues,
};

const FORM_NAME = 'SCI1001FORM';

Container = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
  validate: validate,
})(connect((state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
  };
})(Container));

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withRouter(Container)),
);
